<template>
  <div
    class="Cell"
    :class="{
      'sortable' : sort
    }"
    @click="toggle"
  >
    <slot></slot>

    <span class="ml10">
      <template v-if="sort">
        <!-- <i
          v-if="value.by !== sort"
          class="fas fa-sort"
        ></i> -->

        <i
          :class="{
            'invisible' : value.by !== sort,
            'hidden' : value.by === sort,
            'fas fa-sort' : true
          }"></i>

        <i
          :class="{
            'hidden' :
                value.by !== sort ||
                value.order !== 'asc',

            [ ascIcon ] : true
          }"></i>

        <i
          :class="{
            'hidden' :
                value.by !== sort ||
                value.order !== 'desc',

            [ descIcon ] : true
          }"></i>
      </template>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object
      },

      sort: {
        type: String,
        default: null
      },

      descIcon: {
        type: String,
        default: 'fas fa-sort-down'
      },

      ascIcon: {
        type: String,
        default: 'fas fa-sort-up'
      }
    },

    methods: {
      toggle () {
        if (!this.value) {
          return;
        }

        if (this.value.by === this.sort) {
          this.value.order = this.value.order === 'desc' ? 'asc' : 'desc';
        }

        this.value.by = this.sort;
        this.$emit ('input', this.value);
      }
    }
  };
</script>

<style lang="scss">
  .Cell {
    display: table-cell;
  }

  .sortable {
    &:hover {
      color: rgba(var(--orange), 1);
      cursor: pointer;
    }
  }
</style>